import React from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'


import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'


import useStateObject from '~/client/hooks/useStateObject'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import useStateObject from '~/client/hooks/useStateObject'
import useToggle from '~/client/hooks/useToggle'

import Link from '~/client/components/Link'
import ButtonRow from '~/client/components/ButtonRow'
import ErrorMessage from '~/client/components/ErrorMessage'
import Timestamp from '~/client/components/Timestamp'
import Form from '~/client/components/Form'
import FormButtonRow from '~/client/components/FormButtonRow'
import LoadingList from '~/client/components/LoadingList'
import DocumentTypeInput from '~/client/components/DocumentTypeInput'
import DataCreateForm from '~/client/components/DataCreateForm'
import JSONSchemaFormInput from '~/client/components/JSONSchemaFormInput'

import InspectObject from '~/client/components/InspectObject'
import { useCurrentUser } from '~/client/hooks/auth'

export default function NewDocumentPage(props) {
  const navigate = useNavigate()
  const { documentTypeId } = useParams()
  const { currentUser } = useCurrentUser()
  const query = useQuery('documentTypes.getById', { id: documentTypeId })
  const documentType = query.result
  return <Container>
    <Paper sx={{p: 2, my: 1}}>
      <Typography variant="h5" mb={2}>
        New {documentType ? `"${documentType.name}" ` : ''}Document
      </Typography>

      <DataCreateForm {...{
        documentTypeId,
        onSuccess(newDocument){
          navigate(`/data/${newDocument.id}`)
        },
      }}/>
    </Paper>
  </Container>
}
